import { resolve, type SelectionAttributes } from "@otto-ec/nexus-registry/selection";
import { isMobile } from "../util/Breakpoint";
import { heureka } from "@otto-ec/heureka";
import { isActive } from "../toggle/Toggle";
import { hcSheetState } from "../hcSheet/hcSheetState.svelte";
import { createLog } from "../util/log";

const log = createLog("batch");

export type MergeFn = (changes: SelectionAttributes[]) => SelectionAttributes;
type Handler = (attributes: SelectionAttributes) => unknown;

/*                                                */
let accumulated: SelectionAttributes[] = [];

export async function resolvePreview(attributes: SelectionAttributes) {
  heureka.dresonRule_resolve.emit();
  const { selection } = await resolve({ attributes }, { commit: false });
  heureka.dresonRule_resolved.emit(selection);
}

/**
 *
 *
 *
 *
 */
export function accumulateOnMobile(f: Handler, alternative: Handler): Handler {
  if (isMobile()) {
    return (attributes: SelectionAttributes) => {
      if (isActive("HEUREKA_2349_BATCH_DRESONRULE_ON_MOBILE") && hcSheetState.open) {
        accumulated.push(attributes);
        log.debug("selection accumulated and only previewed, sheet is open", {
          pending: accumulated.length,
          attributes,
        });
        return alternative(attributes);
      } else {
        log.debug("selection committed immediately", {
          batchToggleActive: isActive("HEUREKA_2349_BATCH_DRESONRULE_ON_MOBILE"),
          sheetOpen: hcSheetState.open,
          attributes,
        });
        return f(attributes);
      }
    };
  } else {
    return f;
  }
}

/**
 *
 *
 *
 *
 */
export function submitAccumulated(f: Handler, mergeFn: MergeFn) {
  if (accumulated.length === 0) {
    log.debug("nothing accumulated, nothing to submit");
    return;
  }
  const merged = mergeFn(accumulated);
  /*                                                                                                            */
  log.debug("submitting accumulated selections", { count: accumulated.length, changes: [...accumulated], merged });
  accumulated = [];
  return f(merged);
}
